module.exports = __webpack_public_path__ + "static/media/phone5.0d43f8d7.svg";